export default "//cdn.scentbird.com/assets/frontbird-site/images/antiBacterial_2bb118.png";